const customMenuProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  sx: {
    '& .MuiPaper-root': {
      transformOrigin: 'left top !important',
    },
    '& .MuiList-root': {
      textAlign: 'left',
    },
  },
}

export const BOILERS_DEFAULT_QUERY = {
  _pagina: '1',
  _num_x_pagina: '5',
}

export const BOILERS_SELECTORS = [
  {
    name: 'provincia',
    label: 'Provincia',
    selector: 'provincias',
    cleanup: ['municipio'],
    size: 'small',
    multiple: false,
    defaultFilter: 'Selecciona provincia',
    MenuProps: customMenuProps,
  },
  {
    name: 'municipio',
    label: 'Municipio',
    selector: 'municipios',
    cleanup: ['_pagina'],
    size: 'small',
    multiple: false,
    defaultFilter: 'Selecciona municipio',
    MenuProps: customMenuProps,
  },
]
